import React from "react";

import { trackAmplitudeEvent } from "../../amplitude";
import AddSentenceToCollectionModal from "../AddSentenceToCollectionModal";
import { CLOZE_MODE, STORIES_EVENTS } from "../Stories/storiesEvents";

export default class ClozeTextAddSentence extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      modalVisible: false
    };
  }

  componentDidMount() {
    $('body')
      .on('click', '#translation-popover .add-to-collection.btn', (e) => {
        e.preventDefault();

        const $sentence = $('.sentence.popovered');
        const text = $sentence.data('text');
        const selection = $('#translation-popover').find('.selection').text();
        const parts = text.split(selection, 2);

        $sentence.popover('destroy').removeClass('highlight');

        this.setState({
          collectionClozeSentence: { text: parts[0] + '{{' + selection + '}}' + parts[1] },
          modalVisible: true,
        });
      })
      .on('click', '.sentence .add-to-collection', (e) => {
        const cs = $(e.currentTarget).data('cloze-sentence');
        this.setState({
          collectionClozeSentence: { text: cs['preClozeStr'] + '{{' + cs['cloze'] + '}}' + cs['postClozeStr'] },
          modalVisible: true,
        });
      });
  }

  renderModal() {
    if(!this.state.modalVisible) {
      return null;
    }

    return (
      <AddSentenceToCollectionModal
        collectionClozeSentence={this.state.collectionClozeSentence}
        collectionsUrl={this.props.collectionsUrl}
        isPro={this.props.isPro}
        nextReviewByLevel={this.props.nextReviewByLevel}
        onHidden={() => this.setState({ modalVisible: false, collectionClozeSentence: null })}
        onSentenceAdded={() => {
          trackAmplitudeEvent(STORIES_EVENTS.SENTENCE_ADDED, { mode: CLOZE_MODE, story_id: this.props.storyId });
          this.addSentenceToCollectionModal.hide();
        }}
        ref={(el) => this.addSentenceToCollectionModal = el}
      />
    );
  }

  render() {
    return this.renderModal();
  }
}
